
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Es gibt genetische Risikofaktoren, die in manchen Familien gehäuft vorkommen.
Sicher ist, dass die Migräne eine genetische Grundlage hat. Mittlerweile sind 44
Genvarianten auf 38 Risikogenen dafür bekannt. Zahlreiche davon sind in den
Bereichen des Erbguts lokalisiert, die das Blutkreislaufsystem und die
Energieversorgung des Gehirns regulieren. Das weist darauf hin, dass eine
Störung der Energieversorgung des Gehirns wesentlich für die Entstehung ist.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;